import { useField, useFormikContext } from 'formik';
import { Field, Textarea, type FieldConfig, type TextareaProps } from '@kolking/react-ui';

import { useSpec } from './YupSpecContext';

interface FormTextareaProps extends FieldConfig, TextareaProps {
  name: string;
}

export const FormTextarea = ({
  id,
  name,
  label,
  help,
  className,
  disabled = false,
  readOnly,
  required,
  children,
  ...props
}: FormTextareaProps) => {
  const { isSubmitting, submitCount } = useFormikContext();
  const [{ value, ...field }, meta] = useField<unknown>(name);
  const error = meta.touched || submitCount ? meta.error : undefined;
  const spec = useSpec();

  return (
    <Field
      className={className}
      required={spec.isRequired(name, required)}
      label={spec.label(name, label)}
      help={help}
      id={id ?? name}
    >
      <div data-field-control>
        <Textarea
          {...props}
          {...field}
          id={id ?? name}
          disabled={spec.isDisabled(name, disabled || isSubmitting)}
          readOnly={spec.isReadOnly(name, readOnly)}
          error={error}
          value={typeof value === 'string' ? value : ''}
        />
        {children}
      </div>
    </Field>
  );
};
